import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {
  email: any;
  name: any;
  phone: any;
  emailNote: any;
  contactFormGroup: FormGroup;

  constructor(private spinner: NgxSpinnerService, private route: ActivatedRoute) { }

  ngOnInit(): void {

  }

}
